import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * «Удалить только у себя» — locally hides a conversation from the native list
 * (which is contact-driven, so Stream's `channel.hide()` alone wouldn't remove
 * the row). Keyed by the conversation key `${entityType}:${entityId}`. In-memory
 * set for synchronous reads, persisted to AsyncStorage.
 */
const KEY = 'chat_hidden';
let cache = new Set<string>();
let loaded = false;

/** Load persisted hidden keys into memory (call once early). */
export async function loadHiddenChats(): Promise<void> {
  if (loaded) return;
  loaded = true;
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (raw) cache = new Set<string>(JSON.parse(raw));
  } catch {
    /* first run / parse error — empty set */
  }
}

/** Sync check — is this conversation hidden from my list? */
export function isChatHidden(key: string): boolean {
  return cache.has(key);
}

/** Hide / unhide and persist. */
export async function setChatHidden(key: string, hidden: boolean): Promise<void> {
  if (hidden) cache.add(key);
  else cache.delete(key);
  try {
    await AsyncStorage.setItem(KEY, JSON.stringify([...cache]));
  } catch {
    /* persistence best-effort */
  }
}
